// Per-SKU quantity cap. Ported from the legacy app
// (al_spare_parts/src/constants/AppConstants.js). The cart and product card
// both clamp here so the cart can never exceed the limit by combining a
// stepper bump on the product card with an existing line in the cart.
export const QTY_UPPER_LIMIT = 30
